import Pagination from '@mui/material/Pagination';
import PaginationItem from '@mui/material/PaginationItem';
import {
  gridPageCountSelector,
  gridPageSelector,
  useGridApiContext,
  useGridSelector,
} from '@mui/x-data-grid';

const CustomPagination = () => {
  const apiRef = useGridApiContext();
  const page = useGridSelector(apiRef, gridPageSelector);
  const pageCount = useGridSelector(apiRef, gridPageCountSelector);

  return (
    <Pagination
      page={page + 1}
      count={pageCount}
      siblingCount={2}
      boundaryCount={1}
      showFirstButton={false}
      showLastButton={false}
      onChange={(_, value) => apiRef.current.setPage(value - 1)}
      sx={{
        '& .MuiPagination-ul': {
          gap: '8px',
          flexWrap: 'nowrap',
        },
      }}
      renderItem={item => {
        // Replace Prev/Next with text
        if (item.type === 'previous') {
          return (
            <PaginationItem
              {...item}
              sx={{
                margin: 0,
                borderRadius: '8px',
                minWidth: '72px',
                height: '40px',
                fontSize: '14px',
                fontWeight: 500,
                color: '#6B7280',
                '&:hover': {
                  backgroundColor: '#F3F4F6',
                },
                '&.Mui-disabled': {
                  color: '#9CA3AF',
                  opacity: 1,
                },
              }}
            >
              Prev
            </PaginationItem>
          );
        }

        if (item.type === 'next') {
          return (
            <PaginationItem
              {...item}
              sx={{
                margin: 0,
                borderRadius: '8px',
                minWidth: '72px',
                height: '40px',
                fontSize: '14px',
                fontWeight: 500,
                color: '#6B7280',
                '&:hover': {
                  backgroundColor: '#F3F4F6',
                },
                '&.Mui-disabled': {
                  color: '#9CA3AF',
                  opacity: 1,
                },
              }}
            >
              Next
            </PaginationItem>
          );
        }

        // Page numbers & ellipsis
        return (
          <PaginationItem
            {...item}
            sx={{
              margin: 0,
              borderRadius: '8px',
              minWidth: '40px',
              height: '40px',
              fontSize: '14px',
              fontWeight: 500,
              color: '#6B7280',
              '&.Mui-selected': {
                backgroundColor: '#DBEAFE',
                color: '#2563EB',
                fontWeight: 600,
                '&:hover': {
                  backgroundColor: '#DBEAFE',
                },
              },
              '&:hover': {
                backgroundColor: '#F3F4F6',
              },
              '&.MuiPaginationItem-ellipsis': {
                color: '#9CA3AF',
                fontWeight: 400,
                width: '40px',
              },
            }}
          />
        );
      }}
    />
  );
};

export default CustomPagination;
